export const dayHeadings = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around"
};

export const dayBox = {
    textAlign: "center"
};

export const dayBoxBold = {
    textAlign: "center",
    fontWeight: "bold",
    color: "red",
    cursor: "pointer"
};
